'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import thumbnail from './small-1.jpg';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _lib = require('helpers/lib');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardSliderMobile = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CardSliderMobile, _Component);

  function CardSliderMobile() {
    (0, _classCallCheck3.default)(this, CardSliderMobile);
    return (0, _possibleConstructorReturn3.default)(this, (CardSliderMobile.__proto__ || (0, _getPrototypeOf2.default)(CardSliderMobile)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardSliderMobile, [{
    key: 'toShopDetail',
    value: function toShopDetail(shop) {
      _reactGa2.default.event({
        category: 'Shop',
        action: 'Clicked Shop Card from Shop',
        label: '' + shop.name
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./CardSliderMobile.scss');
      var shop = this.props.shop;

      var reviews = shop.reviews.reverse();
      var totalPoint = 0;
      reviews.map(function (review) {
        totalPoint += review.rating;
      });
      var styleThumbnail = {
        background: 'url(\'' + (0, _lib.getUrlImage)(shop.image) + '\')'
      };
      var averagePoint = reviews.length > 0 ? Math.round(totalPoint / reviews.length * 10) / 10 : 0;
      var colorRatingCode = (0, _lib.getColorRatingCode)(averagePoint);
      var stylePoint = {
        backgroundColor: colorRatingCode
      };
      return _react2.default.createElement(
        _reactRouter.Link,
        {
          className: styles.name,
          to: shop.handle,
          onClick: function onClick() {
            return _this2.toShopDetail(shop);
          }
        },
        _react2.default.createElement(
          'div',
          { className: styles.cardSlider },
          _react2.default.createElement('div', { className: styles.thumbnail, style: styleThumbnail }),
          _react2.default.createElement(
            'div',
            { className: styles.info },
            _react2.default.createElement(
              'div',
              { className: styles.namePoint },
              _react2.default.createElement(
                'div',
                { className: styles.point, style: stylePoint },
                averagePoint !== 0 ? averagePoint : '--'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.name },
                shop.name
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.address },
              shop.address
            )
          )
        )
      );
    }
  }]);
  return CardSliderMobile;
}(_react.Component), _class.propTypes = {
  shop: _react.PropTypes.object
}, _temp);
exports.default = CardSliderMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/CardSliderMobile.js
// module id = 711
// module chunks = 0